import './css/aboutMe.css';

export const AboutMeView = () => {
    return (
        <>
            <p className='aboutMe-text'>
            Desde que logro recordar soy apasionado de la tecnología y de la música. Empecé a programar cuando tenía 13 años,
            durante la cuarentena. Mis primeros pasos fueron con C#, haciendo videojuegos en Unity. No tardé en meterme al mundo
            del desarrollo web, pues me resultó la tecnología más accesible y cómoda a esa edad.
            </p>

            <p className='aboutMe-text'>
            Ahora estoy empezando a explotar los conocimientos y la práctica que he estado cultivando estos años, haciendo proyectos
            vistosos, que demuestren mi talento. Diariamente, trabajo en mis habilidades y busco formas de mejorarlas, leyendo blogs,
            artículos o incluso documentación, con el objetivo de conseguir tener unos conocimientos más completos cada día que pasa.
            </p>

            <p className='aboutMe-text'>
            Soy una persona proactiva, que aprende muy rápido y disfruta colaborando con grupos en los que puede aprender. Entre mis
            aficiones no solo están las páginas web, también está el hardware, la electrónica, la robótica, o en general cualquier 
            cosa que tenga que ver con la tecnología.
            </p>

        </>
    )
}